import React, {Component, ReactElement, ReactNode} from 'react'

import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    NatGetAdminBulletinBoardThread,
    ResultData as ThreadResultData,
    ThreadToFileImage,
} from './repository/NatGetAdminBulletinBoardThread'
import {
    CommentInfo,
    NatGetAdminBulletinBoardThreadCommentList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetAdminBulletinBoardThreadCommentList'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {SortDirection} from '@mui/material/TableCell'
import {Messages} from '../../../Messages'
import {
    MESSAGE_TYPE,
    ROLE_TYPE,
    THREAD_CATEGORY,
    THREAD_PRIORITY,
    VALID_OR_NOT_CHECK,
    VIEW_DO_OR_NOT,
} from '../../../CodeMaster'
import styled from 'styled-components'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {Box, Card, CardMedia, Link, Table, TableBody, TableCell, TableRow, Typography} from '@mui/material'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {SortOrder} from '../../../components/shared/SortOrder'
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {getFileIconPath} from '../../common/util/Natutil'
import {NatPutBulletinBoardThread, NatPutBulletinBoardThreadParams} from './repository/NatPutBulletinBoardThread'
import {isIE} from 'react-device-detect'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Location} from 'react-router-dom'


interface Props {
    threadId: number
    bulletinBoardRepo: NatBulletinBoardRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    isLoadCompleted: boolean
    threadInfo: ThreadResultData
    commentList: CommentInfo[]
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    commentSearchResult: SearchResult
}

class NatAdminBulletinBoardThreadPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            searchCondition: {
                threadId: this.props.threadId,
            },
            searchConditionPageInfo: {
                pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
            searchConditionSortInfo: [
                new SortOrder('updateDatetime', 'desc'),
            ],
            commentSearchResult: {
                total: 0,
            },
            isLoadCompleted: false,
            commentList: [],
            threadInfo: {
                threadId: 0,
                condominiumCd: '',
                title: '',
                categoryId: '',
                userId: '',
                roleName: '',
                contributorRidgeName: '',
                contributorRoomNumber: '',
                contributorFamilyName: '',
                contributorFirstName: '',
                priority: '',
                detail: '',
                invisible: '',
                replyCount: 0,
                alreadyReadCount: 0,
                threadToFileImage: [],
                threadToFileOther: [],
                version: 0,
            },
        }

        this.threadVisibilityControlCancel = this.threadVisibilityControlCancel.bind(this)
        this.threadVisibilityControlOk = this.threadVisibilityControlOk.bind(this)
        this.threadVisibilityControl = this.threadVisibilityControl.bind(this)
        this.backThreadList = this.backThreadList.bind(this)
        this.registerComment = this.registerComment.bind(this)
        this.handleSortCommentList = this.handleSortCommentList.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // CSRFトークンを設定するために、GETのAPIを実行
            await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            // スレッド既読管理登録
            await this.props.asyncCallFunction(
                this.props.bulletinBoardRepo.postBulletinBoardThreadRead.bind(
                    this.props.bulletinBoardRepo, this.props.threadId,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0001.toString('スレッド既読管理')},
            )

            // スレッド取得(管理)
            const bulletinBoardThreadResponse: Nullable<NatGetAdminBulletinBoardThread> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.getAdminBulletinBoardThread.bind(
                        this.props.bulletinBoardRepo, this.props.threadId),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
            if (bulletinBoardThreadResponse && bulletinBoardThreadResponse.details) {
                this.setState({
                    threadInfo: bulletinBoardThreadResponse.details,
                })
            } else {
                return
            }

            // コメント一覧取得(管理)
            const bulletinBoardThreadCommentResponse:
                Nullable<NatGetAdminBulletinBoardThreadCommentList> = await this.getCommentList()

            if (bulletinBoardThreadCommentResponse && bulletinBoardThreadCommentResponse.details) {
                this.setState({
                    commentList: bulletinBoardThreadCommentResponse.details.commentInfo,
                    commentSearchResult: bulletinBoardThreadCommentResponse.details.searchResult,
                })
            } else {
                return
            }

            this.showInitialMessage()

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    // 表示する/表示しないリンク押下
    async threadVisibilityControl(): Promise<void> {
        this.beforeUserAction()
        if (!this.state.threadInfo) {
            return
        }
        let errorLevel: MESSAGE_TYPE
        let message: string = ''
        if (this.state.threadInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value) {
            // 表示する(現在、表示しない状態)
            errorLevel = Messages.IOPCA0003.errorLevel
            message = Messages.IOPCA0003.toString('スレッド', this.state.threadInfo.title)
        } else {
            // 表示しない(現在、表示する状態)
            errorLevel = Messages.IOPCA0004.errorLevel
            message = Messages.IOPCA0004.toString('スレッド', this.state.threadInfo.title)
        }
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: errorLevel,
                message: message,
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.threadVisibilityControlCancel,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.threadVisibilityControlOk,
                    },
                ],
            },
        )
    }

    threadVisibilityControlCancel(): void {
        this.props.eventEmitter.closeDialog()
    }

    async threadVisibilityControlOk(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        const putBulletinBoardThreadParams: NatPutBulletinBoardThreadParams = {
            invisible: this.state.threadInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value ?
                VIEW_DO_OR_NOT.DISPLAY.value : VIEW_DO_OR_NOT.HIDDEN.value,
            version: this.state.threadInfo.version,
        }

        try {
            const response: Nullable<NatPutBulletinBoardThread> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.putBulletinBoardThread.bind(
                        this.props.bulletinBoardRepo, this.props.threadId, putBulletinBoardThreadParams,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('スレッド')},
                )
            if (response && response.requestError === null) {
                this.props.navigate(`/admin/bulletinBoardThreadList`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: this.state.threadInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value ?
                                    Messages.IOPCA0001.toString('スレッド', this.state.threadInfo.title) :
                                    Messages.IOPCA0002.toString('スレッド', this.state.threadInfo.title),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    backThreadList(): void {
        this.props.navigate(
            `/admin/bulletinBoardThreadList`,
        )
    }

    // 登録ボタン押下
    async registerComment(): Promise<void> {
        this.props.navigate(
            `/admin/bulletinBoardThreadCommentRegister/${this.props.threadId}`,
        )
    }

    async getCommentList(searchConditionSortInfo?: SortOrder[]):
        Promise<NatGetAdminBulletinBoardThreadCommentList | null> {
        await this.props.eventEmitter.showLoading()
        try {
            const searchParams: string[] = []

            if (!searchConditionSortInfo) {
                searchConditionSortInfo = this.state.searchConditionSortInfo
            }

            if (searchConditionSortInfo) {
                searchConditionSortInfo.forEach((sortInfo, index) => {
                    const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                    searchParams.push(`sortInfo=${value}`)
                })
            }

            const bulletinBoardThreadCommentResponse: Nullable<NatGetAdminBulletinBoardThreadCommentList> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.getAdminBulletinBoardThreadCommentList.bind(
                        this.props.bulletinBoardRepo, this.props.threadId, searchParams.join('&')),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            return bulletinBoardThreadCommentResponse

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleSortCommentList(sortKey: string): Promise<void> {
        this.beforeUserAction()
        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]

        // コメント一覧取得(管理)
        const bulletinBoardThreadCommentResponse:
            Nullable<NatGetAdminBulletinBoardThreadCommentList> = await this.getCommentList(sortOrders)

        if (bulletinBoardThreadCommentResponse && bulletinBoardThreadCommentResponse.details) {
            this.setState({
                commentList: bulletinBoardThreadCommentResponse.details.commentInfo,
                commentSearchResult: bulletinBoardThreadCommentResponse.details.searchResult,
                searchConditionSortInfo: sortOrders,
            })
        } else {
            return
        }

    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }


    renderPageHeaderArea(): ReactElement {
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_BOARD_MANAGEMENT}>
                    <PageFotterAreaRight>
                        <StyledLink
                            onClick={this.threadVisibilityControl}>
                            {(this.state.threadInfo &&
                            this.state.threadInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value ?
                                VIEW_DO_OR_NOT.DISPLAY.label : VIEW_DO_OR_NOT.HIDDEN.label)
                            }
                        </StyledLink>
                    </PageFotterAreaRight>
                </AuthorityChecker>
            </>
        )
    }

    renderImageCard(threadImages: ThreadToFileImage[]): ReactElement {
        return (<>{
            threadImages.map((image, index) => {
                return (
                    <Box
                        ml={(index !== 0) ? '10px' : undefined}
                        key={index}
                    >
                        <Card>
                            <StyledCardContent>
                                <CardMedia
                                    style={{maxWidth: '200px', maxHeight: '200px'}}
                                    component={'img'}
                                    src={image.path}
                                />
                            </StyledCardContent>
                        </Card>
                    </Box>
                )
            })
        }</>)
    }

    renderPageBodyThreadInfoArea(): ReactElement {
        return (
            <>
                <Box marginTop={'10px'}>
                    <Table>
                        <StyledTableCaption>スレッド情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName>カテゴリ</TableRowName>
                                <TableCell colSpan={3}>
                                    {THREAD_CATEGORY.codeToEnumConstants(this.state.threadInfo.categoryId).label}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>優先度</TableRowName>
                                <TableCell colSpan={3}>
                                    {THREAD_PRIORITY.codeToEnumConstants(this.state.threadInfo.priority).label}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>タイトル</TableRowName>
                                <TableCell colSpan={3}>{this.state.threadInfo.title}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>部屋番号</TableRowName>
                                <TableCell colSpan={3}>
                                    {(this.state.threadInfo.userId.slice(0, 1) === ROLE_TYPE.RESIDENT.value) ?
                                        `${this.state.threadInfo.contributorRidgeName} ${this.state.threadInfo.contributorRoomNumber}`
                                        : ''
                                    }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>投稿者</TableRowName>
                                <TableCell colSpan=
                                               {(this.state.threadInfo.userId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                                   2 : 3}>
                                    {`${this.state.threadInfo.contributorFamilyName} ${this.state.threadInfo.contributorFirstName}`}
                                </TableCell>
                                {(this.state.threadInfo.userId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                    <TableCell>
                                        {Messages.INTFA0028.toString(this.state.threadInfo.roleName)}
                                    </TableCell>
                                    :
                                    ''
                                }
                            </TableRow>
                            <TableRow>
                                <TableRowName>詳細</TableRowName>
                                <TableCellWordBreakAll colSpan={3}>
                                    <div dangerouslySetInnerHTML={{__html: this.state.threadInfo.detail}}/>
                                </TableCellWordBreakAll>
                            </TableRow>
                            <TableRow>
                                <TableRowName>既読者</TableRowName>
                                <TableCell colSpan={3}>{this.state.threadInfo.alreadyReadCount}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>コメント数</TableRowName>
                                <TableCell colSpan={3}>{this.state.threadInfo.replyCount}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>画像</TableRowName>
                                <TableCell colSpan={3}>
                                    <LeftRowFlexContainer>
                                        {this.renderImageCard(this.state.threadInfo.threadToFileImage)}
                                    </LeftRowFlexContainer>
                                </TableCell>
                            </TableRow>
                            {(this.state.threadInfo.threadToFileOther.length > 0) ?
                                this.state.threadInfo.threadToFileOther.map((threadFile, index) => (
                                    <TableRow key={`index_${index}`}>
                                        {index === 0 &&
                                            <TableRowName
                                                rowSpan={this.state.threadInfo.threadToFileOther.length}>ファイル</TableRowName>
                                        }

                                        <ThredFileIconCell>
                                            {this.getFileLink(
                                                threadFile.fileName, threadFile.path, threadFile.fileNameExtension)}
                                        </ThredFileIconCell>
                                        <TableCell>
                                            {threadFile.fileName}
                                        </TableCell>
                                        <TableCell>並び順 {threadFile.sortOrder}</TableCell>

                                    </TableRow>
                                )) :
                                <TableRow>
                                    <TableRowName>ファイル</TableRowName>
                                    <TableCell colSpan={3}></TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </Box>
            </>
        )
    }

    getFileLink(fileName: string, filePath: string, fileNameExtension: string): ReactElement {
        switch (fileNameExtension.toUpperCase()) {
            case 'PDF':
                if (isIE) {
                    return (
                        <LinkForIe onClick={() => window.open(filePath)}
                                   target={'_blank'}>
                            <img src={getFileIconPath(fileNameExtension)}
                                 alt=""/>
                        </LinkForIe>
                    )
                } else {
                    return (
                        <Link href={filePath} target={'_blank'} underline="hover">
                            <img src={getFileIconPath(fileNameExtension)}
                                 alt=""/>
                        </Link>
                    )
                }
                break
            default:
                return (
                    <Link href={filePath} download underline="hover">
                        <img src={getFileIconPath(fileNameExtension)}
                             alt=""/>
                    </Link>
                )
                break
        }
    }

    renderPageBodyCommentInfoArea(): ReactElement {
        return (
            <>
                <Table>
                    <StyledTableCaption>コメント情報</StyledTableCaption>
                </Table>
                {(this.state.commentList.length === 0) ?
                    <Box mt={'5px'} ml={'10px'}>
                        <Typography variant={'body2'}>
                            {Messages.IOPCC0015.toString('コメント')}
                        </Typography>
                    </Box> : <></>
                }
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_BOARD_MANAGEMENT}>
                        <NewButtonStyle onClick={this.registerComment}>
                            新規
                        </NewButtonStyle>
                    </AuthorityChecker>
                </SearchPageActionArea>
                {(this.state.commentList.length > 0) ?
                    this.renderCommentTable() : <></>
                }

            </>
        )
    }


    renderCommentTable(): Nullable<ReactElement> {
        const headers: SortableTableHeaderCell[] = [
            {id: 'commentId', label: 'コメントID'},
            {id: 'comment', label: 'コメント内容'},
            {id: 'roomNumber', label: '部屋番号'},
            {id: 'contributor', label: '投稿者'},
            {id: 'invisible', label: '非表示'},
            {
                id: 'updateDatetime',
                label: '更新日時',
                sortable: true,
                direction: this.getSortDirection('updateDatetime'),
            },
        ]

        return (
            <Table stickyHeader>
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortCommentList}
                />
                <TableBody>
                    {this.state.commentList.map(
                        (commentInfo, index) => this.renderCommnetRecord(commentInfo, index),
                    )}
                </TableBody>

            </Table>

        )
    }

    renderCommnetRecord(commentInfo: CommentInfo, index: number): Nullable<ReactElement> {

        const commentUrl: string =
            `/admin/bulletinBoardThread/${commentInfo.threadId}/${commentInfo.commentId}`

        const invisibleForDisplay = commentInfo.invisible === VALID_OR_NOT_CHECK.NOT.value ?
            VALID_OR_NOT_CHECK.NOT.label : VALID_OR_NOT_CHECK.VALID.label


        return (
            <TableRow key={index}>
                <TableCellWordBreakAll align={'center'}>
                    <Link href={commentUrl} underline="hover">{commentInfo.commentId}</Link>
                </TableCellWordBreakAll>
                <TableCellWordBreakAll align={'center'}>
                    <div dangerouslySetInnerHTML={{__html: commentInfo.comment}}/>
                </TableCellWordBreakAll>
                <TableCellWordBreakAll align={'center'}>
                    {(commentInfo.userId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                        '-' : `${commentInfo.contributorRidgeName} ${commentInfo.contributorRoomNumber}`
                    }
                </TableCellWordBreakAll>
                <TableCellWordBreakAll align={'center'}>
                    {`${commentInfo.contributorFamilyName} ${commentInfo.contributorFirstName}`}
                </TableCellWordBreakAll>
                <TableCellWordBreakAll align={'center'}>
                    {invisibleForDisplay}
                </TableCellWordBreakAll>
                <TableCellWordBreakAll align={'center'}>
                    {formatDateTimeForUpdateDate(commentInfo.updateDatetime)}
                </TableCellWordBreakAll>
            </TableRow>
        )
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backThreadList}
                    >
                        スレッド検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageFooterArea>
                    {this.renderPageHeaderArea()}
                </PageFooterArea>
                <PageMainArea>
                    {this.renderPageBodyThreadInfoArea()}
                </PageMainArea>
                <PageMainArea>
                    {this.renderPageBodyCommentInfoArea()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

}

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

const ThredFileIconCell = styled(TableCell)`
  &.MuiTableCell-root {
    width: 100px;
  }
`

const NewButtonStyle = styled(AdminDefaultMediumButton)`
  margin-bottom: 10px;
`

const LinkForIe = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
`

const StyledCardContent = styled.div`
  background-color: #EEEEEE;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default createAdminPage(NatAdminBulletinBoardThreadPage)

